<template>
<div @click="$router.push('/mail-log')" class="email-indicator clickable" :class="{visible}">
    <v-icon color="white">email</v-icon>
    <div class="email-indicator-text">
        {{currentStatus}}
        <div class="truncate email-indicator-subtext">{{emailToValue}}</div>
    </div>
    <div>
        <v-icon @click="hide" small dark color="white">close_circle_outline</v-icon>
    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import Firestore from '../data/Firestore'

export default {
    data() {
        return {
            visible: false,
            log: {},
        }
    },

    components: {
        
    },
    
    props: {
     
    },

    computed: {
        currentStatus() {
            const log = this.log
            if(!log || !log.statuses) 
                return ''
            const statuses = log.statuses
            if(statuses.open)
                return 'Open'
            else if(statuses.delivered)
                return 'Delivered'
            else if(statuses.sent)
                return 'Sent'
            else if(statuses.queued)
                return 'Queued'
            else
                return 'Waiting...'
        },
        emailToValue() {
            const log = this.log
            if(!log || !log.email || !log.email.to)
                return ''
            return log.email.to[0].email 
        }

    },

    methods: {
        show(logId) {
            const ref = Firestore.getCollectionDocumentRefFromPath('teams/global/collections/mail/data').doc(logId)
            Firestore.streamDocument(ref, this.log)
            this.visible = true
            setTimeout( () => {
                this.visible = false
            }, 15000)
        },
        hide() {
            this.visible = false
        },
        loadLog() {

        },

    },

    created() {

    }
}
</script>

<style scoped>
   .email-indicator {
       z-index: 300;                            
       /* vuetify dialogs sit at z-index of 200+ */

       position: fixed;
       bottom: -50px; left: calc(50% - 110px);
       width: 220px; height: 40px;
       background-color: rgba(0,0,0,.6);
       padding:8px;
       border-radius:20px;
       display:flex;
       transition:  all .5s ease-in-out;
       opacity: 0;
   }
   .email-indicator.visible {
       bottom:10px!important;
       opacity: 1;
   }
    .email-indicator:hover {
        background-color: rgba(0,0,0,.8);;
    }
   .email-indicator-text {
       margin-top:-3px;
       font-size:14px;
       padding-left:10px;
       flex-grow: 1;
       color: white;
   }
   .email-indicator-subtext {
       font-size:10px;margin-top:-4px;width:150px;
   }
</style>




// WEBPACK FOOTER //
// EmailIndicator.vue?58b8b72e